var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content-container__header"},[_c('h1',[_vm._v(_vm._s(_vm.routeName))]),_c('portal-target',{attrs:{"name":"content-header"}})],1),_c('div',{staticClass:"content-container__view"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }